import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'onboarding',
	dialogId: 'feature-onboarding-modal',
	dialogType: 'modal',
};
